const DEFAULT = Symbol("Default switch case");
const maybeCall = (arg) => {
  return arg instanceof Function ? arg() : arg;
};
const cond = (...args) => {
  for (const arg of args) {
    if (Array.isArray(arg)) {
      if (arg[0]) {
        return maybeCall(arg[1]);
      }
    } else {
      return maybeCall(arg);
    }
  }
  return void 0;
};
const switchCase = (value, ...args) => {
  for (const arg of args) {
    if (Array.isArray(arg)) {
      if (arg[0] === value || arg[0] === DEFAULT) {
        return arg[1]();
      }
    }
    if (arg instanceof Function) {
      return arg();
    }
  }
  return void 0;
};
export {
  DEFAULT,
  cond,
  switchCase
};
